import React, {Component} from 'react'

export default class ToDo extends Component {
	render() {
		return (
			<span style={{backgroundColor: '#c00', color: '#fff', display: 'inline-block', padding: '0.2em 0.2em 0.2em 1.2em', position: 'relative', fontSize: '0.8em', minHeight: '1em'}}>
				<span style={{fontSize: '0.3em', color: '#fff', position: 'absolute', top: 5, left: 5, fontWeight: 'bold'}}>ToDo</span>
				{this.props.children }
			</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/ToDo.js